(function () {
    'use strict';

    angular.module('itxApp.cmsPage').service('CmsPageService', CmsPageService);

    CmsPageService.$inject = ['$injector', '$q', '$rootScope', '$window', '$timeout', 'CmsHeaderService'];

    function CmsPageService($injector, $q, $rootScope, $window, $timeout, CmsHeaderService) {
        let _this = this;

        _this.cartItems = 0;
        _this.initialized = false;

        let HomeAnalitics;
        let Product;
        let imHomeService;
        let imGridService;
        let imProductService;
        let imCategoryFilter;
        let crmService;
        let ItxHeaderFct;
        let NavigationServiceFct;
        let NostromoSvc;
        let UserService;
        let ProductPopupSvc;
        let WidgetService;

        return {
            init: _init,
            initEvents: _initEvents,
            handleClick: _handleClick,
            pageView: _pageView,
            cartItems: _this.cartItems
        };

        // Inicializacion Eventos para el HEADER
        function _initEvents() {
            // ItxShopCartFct = $injector.get('ItxShopCartFct');
            // ItxShopCartFct.getCart();

            UserService = $injector.get('UserService');
            if (UserService.isAuthenticated()) {
                CmsHeaderService.sendLoginCmsEvent();
            }

            $rootScope.$on('login:success', function () {
                if (crmService && crmService.is360()) {
                    document.location.reload();
                }
                CmsHeaderService.sendLoginCmsEvent();
            });

            $rootScope.$on('itx-shop-cart:updated', function name(e, shopCart) {
                _this.cartItems = shopCart.state.totalItems;
                CmsHeaderService.sendCartEvent(_this.cartItems);
            });
        }

        function _init() {
            var deferred = $q.defer();

            document.addEventListener('legacy-event', (event) => {
                if (event && event.detail && event.detail.extra && event.detail.extra.type) {
                    _handleClick(event.detail.extra);
                }
            });

            HomeAnalitics = $injector.get('HomeAnalitics');
            Product = $injector.get('Product');
            imHomeService = $injector.get('imHomeService');

            imGridService = _injectService('imGridService');
            imProductService = $injector.get('imProductService');
            imCategoryFilter = $injector.get('imCategoryFilter');
            crmService = $injector.get('crmService');
            ItxHeaderFct = $injector.get('ItxHeaderFct');
            NavigationServiceFct = $injector.get('NavigationService');
            NostromoSvc = $injector.get('NostromoSvc');

            _this.initialized = true;
            _this.initCustomEvent = false;

            deferred.resolve(_this);
            return deferred.promise;
        }

        function _handleClick(param) {
            if (!_this.initialized) {
                _init().then(function () {
                    _emitAction(param, name);
                });
            } else {
                _emitAction(param, name);
            }
        }

        function _pageView(pageView) {
            if (!_this.initialized) {
                _init().then(function () {
                    imHomeService.createView(pageView);
                });
            } else {
                imHomeService.createView(pageView);
            }
        }

        function _emitAction(param, name) {
            let section = null;
            if (param.pieceName) {
                section = param.pieceName;
            }
            if (param.data && param.data.pieceName) {
                section = param.data.pieceName;
            }

            switch (param.type) {
                case 'category':
                    console.log('DEPRECATED FILE');
                    itxCmsUtilsSvc.doClick(param.categoryId);
                    break;

                case 'menu':
                    console.log('DEPRECATED FILE');
                    if (inditex.hybridPage) {
                        param.typeEvent = param.type;
                        const options = {
                            bubbles: true,
                            composed: true,
                            detail: {
                                extra: param
                            }
                        };
                        document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
                    }
                    break;

                case 'closeMenu':
                    console.log('DEPRECATED FILE');
                    break;

                case 'openMenu':
                    console.log('DEPRECATED FILE');
                    break;

                case 'external':
                    // Casuística provisional para parametros en la url (TODO: añadir tipos de enlace Custom en el CMS)
                    var nameCustomEvent = checkParamCustom(param.src);
                    if (nameCustomEvent) {
                        _customEvent(nameCustomEvent, param);
                        return;
                    }

                    HomeAnalitics.sendPathHttp(param.src, param.type, null, null);
                    window.location.href = param.src;
                    break;

                case 'product':
                    var cmsLookbookSvc = _injectService('cmsLookbookSvc');
                    cmsLookbookSvc.managementActionCms(param);
                    // $rootScope.$broadcast('openProductPopup', param);
                    // var product = new Product(param.productId, null, null, param.categoryId);
                    // window.location.href = product.getUrl();
                    break;

                case 'login':
                    NostromoSvc.login();
                    if (param && param.returnId) {
                        ItxHeaderFct.signIn(param.forceModal, param.preselectedFields, param.returnId);
                    } else if (param) {
                        ItxHeaderFct.signIn(param.forceModal, param.preselectedFields);
                    } else {
                        ItxHeaderFct.signIn();
                    }
                    $timeout();
                    break;
                case 'section':
                    if (param.section === 'userRegister') {
                        NostromoSvc.register();
                        ItxHeaderFct.showRegister();
                    }
                    $timeout();
                    break;
                case 'logout':
                    joyr.rest.xRestLogout().done(function () {
                        NavigationServiceFct.goToHomePage();
                    });
                    break;
                case 'myAccount':
                    window.location.href = joyr.utils.getCommonPageUrl('ItxMyAccountPage', false, false) + '#/menu';
                    break;
                case 'myOrders':
                    window.location.href = joyr.utils.getCommonPageUrl('ItxMyAccountPage', false, false) + '#/orders-type/online';
                    break;
                case 'cart':
                    ItxHeaderFct.toggleMiniCart();
                    $timeout();
                    break;
                case 'changeSection':
                    NavigationServiceFct.goToHomePage(section);
                    break;
                // MENU FOOTER
                case 'footerDownloadApp':
                    _customEvent('goToDownloadApp', {});
                    break;
                case 'footerContact':
                    _customEvent('openContact', {});
                    break;

                // SHOPCART
                case 'setCart':
                    console.log('LA GESTION DE LA CESTA ESTA EN APOLLO');
                    break;

                case 'addCart':
                    // var ItxShopCartFct = $injector.get('ItxShopCartFct');
                    // ItxShopCartFct.addCartApollo(param.product, param.openPopup, false, param.customized).then(function(){
                    //     _updateShopCartCounter();
                    //     ItxShopCartFct.getCart().then((shopCart) => {
                    //         if(shopCart){
                    //             _this.cartItems = shopCart.state.totalItems;
                    //             CmsHeaderService.sendCartEvent(_this.cartItems);
                    //         }
                    //     });
                    // });
                    console.log('LA GESTION DE LA CESTA ESTA EN APOLLO');
                    break;

                case 'addCartWishlist':
                    // var ItxShopCartFct = $injector.get('ItxShopCartFct');
                    // ItxShopCartFct.addCartApollo(param.product, param.openPopup, true, param.customized).then(function(){
                    //     _updateShopCartCounter();
                    //     ItxShopCartFct.getCart().then((shopCart) => {
                    //         if(shopCart){
                    //             _this.cartItems = shopCart.state.totalItems;
                    //             CmsHeaderService.sendCartEvent(_this.cartItems);
                    //         }
                    //     });
                    // });
                    console.log('LA GESTION DE LA CESTA ESTA EN APOLLO');
                    break;

                case 'openRefundForm':
                    var ngDialog = $injector.get('ngDialog');
                    ngDialog.open({
                        template: '<itx-my-account-order-refund-form order="ngDialogData.order"></itx-my-account-order-refund-form>',
                        className: 'new-modal ma-modal-md ma-modal-macro ngdialog-theme-plain ngdialog-order-return ',
                        plain: true,
                        showClose: true,
                        data: {
                            order: param.order
                        }
                    });
                    break;

                case 'goToCart':
                    $window.location.href = joyr.utils.getCommonPageUrl('ItxShopCartPage', false, false);
                    break;
                case 'updateWishlist':
                    $rootScope.$broadcast('buylater:update');
                    break;
                // SHOPCART MULTIPLE PRODUCTS
                case 'addMultipleProductsToCart':
                    console.log('LA GESTION DE LA CESTA ESTA EN APOLLO');
                    break;

                // SIZE
                case 'stockAvailability':
                    ProductPopupSvc = _injectService('productPopupSvc');
                    param.product.state = {
                        selectedColor: param.product.status.selectedColor,
                        selectedSize: param.product.status.selectedSize
                    };
                    ProductPopupSvc.openStockAvailability(param.product);
                    break;
                case 'sizeGuide':
                    var SizeGuideSvc = _injectService('ItxSizeGuideSvc');
                    SizeGuideSvc.openPopup(param.product, 'equivalence');
                    break;
                case 'sizeGuideMeasurements':
                    var SizeGuideSvc = _injectService('ItxSizeGuideSvc');
                    SizeGuideSvc.openPopup(param.product, 'garmentMeasurements');
                    break;
                case 'helpPage':
                    ProductPopupSvc = _injectService('productPopupSvc');
                    ProductPopupSvc.openHelpPage(param.product);
                    break;
                case 'openStock':
                    ProductPopupSvc = _injectService('productPopupSvc');
                    ProductPopupSvc.openStock(param.product, param.selectedIndex, param.productApiLegacy);
                    break;
                case 'imAnalytics':
                    switch (param.service) {
                        case 'product_click':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, null);
                            imGridService.sendProductEvent(legacyProduct, legacyProduct.state.selectedColorIndex);
                            break;
                        case 'pageview_ficha':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, null);
                            imProductService.createView(legacyProduct, legacyProduct.state.selectedColorIndex);
                            break;
                        case 'pageview_ficha_bundle':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, null);
                            imProductService.createViewBundle(legacyProduct, legacyProduct.state.selectedColorIndex);
                            break;
                        case 'anadir_producto_cesta':
                            // var product = param.objData.product;
                            // var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, product.status.selectedSize.sku);
                            // console.log(legacyProduct);
                            // imProductService.eventAddToCart(legacyProduct);
                            break;
                        case 'seleccionar_talla':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, product.status.selectedSize.sku);
                            imProductService.eventSelectSize(legacyProduct, legacyProduct.state.selectedSize, legacyProduct.state.selectedColorIndex);
                            break;
                        case 'seleccionar_color':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, null);
                            imProductService.eventSelectColor(legacyProduct, legacyProduct.state.selectedColorIndex);
                            break;
                        case 'ver_guia_tallas':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, null);
                            imProductService.eventSizeGuide(legacyProduct);
                            break;
                        case 'ver_ayuda_producto':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, null);
                            imProductService.eventProductInfo(legacyProduct, param.objData.type);
                            break;
                        case 'ver_ayuda':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, product.status.selectedColor.id, null, null, null);
                            imProductService.eventHelpPage(legacyProduct);
                            break;
                        case 'ver_zoom':
                            imProductService.eventZoom(param.objData.index);
                            break;
                        case 'pageview_parrilla':
                            imGridService.sendPageView(param.objData.category, param.objData.products);
                            break;
                        case 'related_product_click':
                            var product = param.objData.product;
                            var legacyProduct = new Product(product, null, null, null, null);
                            imProductService.eventRelatedProductClick(legacyProduct, param.objData.type, inditex.iPage);
                            break;
                        case 'cambio_vista':
                            imCategoryFilter.changeView(param.objData.viewType, true);
                            break;
                        default:
                            break;
                    }
                    break;
                case 'customizeDialog':
                    var ProductCustomizeService = _injectService('ProductCustomizeService');
                    ProductCustomizeService.openCustomizeProduct(param.product);
                    break;
                case 'openContact':
                    _openModalContact();
                    break;
                case 'openCookieSettings':
                    if (window.OneTrust) {
                        window.OneTrust.ToggleInfoDisplay();
                    }
                    break;
                case 'openAccessibilityModal':
                    WidgetService = $injector.get('WidgetService');
                    WidgetService.openModal();
                    break;
                default:
                    break;
            }
        }

        /**
         * Función para comprobar si la url pasada contiene parámetros
         */
        function checkParamCustom(url) {
            if (url.indexOf('customEvent') > -1) {
                var paramName = url.split('=');
                if (paramName && paramName[1]) {
                    if (paramName[1].indexOf('&') > -1) {
                        return paramName[1].substring(0, paramName[1].indexOf('&'));
                    } else {
                        return paramName[1];
                    }
                } else {
                    return false;
                }
            }
            return false;
        }

        function _customEvent(name, param) {
            if (!name || !param) {
                return;
            }

            if (!_this.initCustomEvent) {
                _this.initCustomEvent = true;

                _this.ItxHeaderFct = _injectService('ItxHeaderFct');
                _this.mdFeelService = _injectService('mdFeelCmsService');
                _this.ModalSvc = _injectService('ModalSvc');
                _this.mdUtils = _injectService('mdUtils');
            }

            switch (name) {
                case 'openSearch':
                    if (_hasService('ItxHeaderFct') && window.EmpathyX) {
                        _this.ItxHeaderFct.toggleSearch();
                        window.EmpathyX.search('');
                    }
                    break;
                case 'openContact':
                    _openModalContact();
                    break;
                case 'landingFeel':
                    if (_hasService('mdFeelCmsService')) {
                        _this.mdFeelService.initEvents(param.src);
                    }
                    break;
                case 'openCookieSettings':
                    if (window.OneTrust) {
                        window.OneTrust.ToggleInfoDisplay();
                    }
                    break;

                case 'goToDownloadApp':
                    _this.mdUtils.linkDownloadApp();
                    break;
                case 'openAccessibilityModal':
                    WidgetService = $injector.get('WidgetService');
                    WidgetService.openModal();
                    break;
                case 'footerChangeMarket':
                    window.location.href = '/?select-store=true';
                    break;
            }
        }

        function _injectService(service) {
            if (!service) {
                return false;
            }
            if (service && $injector.has(service)) {
                return $injector.get(service);
            } else {
                return false;
            }
        }

        function _hasService(service) {
            if (!service) {
                return false;
            }
            if ($injector.has(service)) {
                return true;
            } else {
                console.error(`No existe el modulo requerido para el servicio ${service} en la pagina: ${inditex.iPage}`);
                return false;
            }
        }

        function _openModalContact(text) {
            _this.ModalSvc = $injector.get('ModalSvc');
            _this.ModalSvc.openContact();
        }

        function _updateShopCartCounter() {
            const options = {
                bubbles: true,
                composed: true,
                detail: {
                    extra: {
                        typeEvent: 'update-shop-cart'
                    }
                }
            };
            document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
        }
    }
})();
